import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// Utils / Mappers
import { unformatPhone } from 'utils/formatString';
import { getFavoriteNumberState, getStep } from './mapper';

// Добавление или смена любимого номера
const FAVORITE_NUMBER_ADD_OR_UPDATE_API_URL = '/favoritenumberapi/addorupdate/';
// Удаление любимого номера;
const FAVORITE_NUMBER_REMOVE_API_URL = '/favoritenumberapi/remove/';
// Стартовый урл по которому получаем нанные на didmount'е;
const FAVORITE_NUMBER_API_URL = '/favoritenumberapi/';
// Урл по которому делаем пулинг на бэк для определения статуса подключения номера;
const POLLING_URL = '/sebtariff/requeststatus';
// Регулярка для парсинга строки и поиска телефона в троке;
const REG_EXP_TELEPHONE_NUMBER = /[\+\d][\. 0-9-\(\)]{7,16}\d/gmi;

class FavoriteNumberWizardModalHoc extends Component {
  count = 0;

  constructor(props) {
    super(props);

    this.state = {
      modalData: null,
      userNumber: null,
      step: null,
      errorType: 'fail',
    };
  }

  componentDidMount() {
    axios.get(FAVORITE_NUMBER_API_URL)
      .then(({ data }) => this.setState({
        ...getFavoriteNumberState({ ...data, ctn: this.props.ctn }),
      }))
      .catch((err) => {
        console.error('Ошибка в get запросе получении favoriteNumber: ', err);
      });
  }

  /** Записывает введенный номер в state; */
  setUserNumber = (userNumber) => {
    const { step, modalData } = this.state;
    const { changeFreeModal, connectModal, changeModal } = modalData;

    const messageObj = {
      changeFree: changeFreeModal,
      connect: connectModal,
      change: changeModal,
    };

    const isValidNumber = userNumber.length === 16 && !userNumber
      .slice(3, userNumber.length).replace(/\s/g, '').match(/^9\d{9}/);

    this.setState({
      userNumber,
      msg: isValidNumber && messageObj[step].validationText,
    });
  };

  /** Устанавливает новый шаг для открытия окна подтверждения */
  openConfirm = () => this.setState({ step: 'confirm' });

  /** Устанавливает новый шаг для открытия окна удаления номера */
  openDeleteNumber = () => this.setState({ step: 'delete' });

  /** Подключение номера */
  onConnect = () => this.sendRequest('connect');

  /** Удаление номера */
  onDelete = () => this.sendRequest('delete');

  /** Закрываем модальное окно, устанавливаем default шаг */
  onCloseModal = () => {
    this.setState((prevState) => ({
      step: getStep(prevState),
      userNumber: null,
    }));
    this.props.closeModal();
  };

  /** Ищем в тексте номер телефона и подменяем его введенным номером в input.
   * Так себе решение, но пока другова не придумал */
  getBeautyConfirmText = (text) => {
    const { userNumber, favoriteNumber, step } = this.state;
    const regExp = text.match(REG_EXP_TELEPHONE_NUMBER);

    let replaceContentText = null;

    if (regExp && regExp.length) {
      const number = regExp[0] === favoriteNumber && step !== 'delete' ? userNumber : favoriteNumber;
      replaceContentText = text.replace(regExp[0], number);
    } else if (userNumber && userNumber.length === 16 || favoriteNumber) {
      replaceContentText = text.replace('{{TEXT}}', userNumber);
    }

    return replaceContentText;
  };

  /** Пулинг запроса на бэк для подключения/отключения/смены */
  polling = (requestId, requestType, timeout) => {
    const performanceTimer = performance.now();
    axios(POLLING_URL, {
      method: 'post',
      data: { requestId },
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((request) => {
        const { data: { isSucceeded, result } } = request;

        if (this.count >= timeout) {
          this.setState({ step: 'error' });
          return;
        }

        if (result === null) {
          const millisec = performance.now() - performanceTimer;
          const seconds = (millisec / 1000);

          this.count += seconds;

          this.polling(requestId, requestType, timeout);
        } else {
          let step = null;
          if (isSucceeded && result) {
            step = 'delSuccess';

            if (requestType === 'connect') {
              step = 'success';
            }
          } else {
            step = 'error';
          }

          this.setState({ step });
        }
      })
      .catch((err) => {
        this.setState({ step: 'error' });
        console.error('Ошибка в post запросе при подключении favoriteNumber: ', err);
      });
  };

  /** Отправыляет запрос на бэк основываясь на типе запроса */
  sendRequest = (type) => {
    this.setState({ step: 'pending' });

    let request = null;
    switch (type) {
      case 'delete':
        request = axios(FAVORITE_NUMBER_REMOVE_API_URL, {
          method: 'post',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        }); break;
      case 'connect':
        request = axios(FAVORITE_NUMBER_ADD_OR_UPDATE_API_URL, {
          method: 'post',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          data: {
            favoriteNumber: unformatPhone(this.state.userNumber),
          },
        }); break;
    }

    request
      .then(({ data }) => {
        const { isSucceeded, requestId, errorCode } = data;

        if (isSucceeded && requestId) {
          this.polling(requestId, type, 30);
          return;
        }

        if (!isSucceeded && errorCode === 'LOWBALANCE') {
          this.setState({
            step: 'error',
            errorType: 'lowBalance',
          });
          return;
        }

        throw new Error();
      })
      .catch(() => {
        this.setState({
          step: 'error',
          errorType: 'fail',
        });
      });
  };

  render() {
    const { children, opened } = this.props;
    const {
      step, userNumber, modalData, msg, errorType,
    } = this.state;

    const isActiveButton = userNumber && userNumber.length === 16 && !msg;

    return modalData ? React.cloneElement(children, {
      openConfirm: this.openConfirm,
      onChange: this.setUserNumber,
      closeModal: this.onCloseModal,
      onConnect: this.onConnect,
      onDelete: this.onDelete,
      openDeleteNumber: this.openDeleteNumber,
      reConnectModal: {
        ...modalData.reConnectModal,
        disabled: isActiveButton,
        msg,
      },
      changeModal: {
        ...modalData.changeModal,
        disabled: isActiveButton,
        msg,
      },
      deleteModal: {
        ...modalData.deleteModal,
        contentText: this.getBeautyConfirmText(modalData.deleteModal.contentText),
      },
      notAllowedModal: modalData.notAllowedModal,
      connectModal: {
        ...modalData.connectModal,
        disabled: isActiveButton,
        msg,
      },
      delSuccessModal: modalData.delSuccessModal,
      confirmModal: {
        ...modalData.confirmModal,
        contentText: this.getBeautyConfirmText(modalData.confirmModal.contentText),
      },
      changeFreeModal: {
        ...modalData.changeFreeModal,
        disabled: isActiveButton,
        msg,
      },
      successModal: {
        ...modalData.successModal,
        contentText: this.getBeautyConfirmText(modalData.successModal.contentText),
      },
      errorModal: modalData.errorModal,
      opened,
      step,
      errorType,
    }) : null;
  }
}

FavoriteNumberWizardModalHoc.propTypes = {
  children: PropTypes.object,
  closeModal: PropTypes.func,
  opened: PropTypes.bool,
  ctn: PropTypes.string,
};

export default FavoriteNumberWizardModalHoc;
